<template>
  <div class="animated fadeIn brief-cambios-original-add">
    <b-card no-header>
      <form>
        <b-form-group
          description="Descripción del cambio solicitado">
          <b-form-textarea
            id="cambios"
            v-model="$v.cambios.$model" 
            rows="5"
            max-rows="5"
            :state="cambiosValidos"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="cambiosFeedback">
            {{ cambiosInvalidosMsj }}
          </b-form-invalid-feedback>
        </b-form-group>
      </form>

      <br>

      <div class="galeria-imagenes">
        <p>Imágenes de Referencia <i class="fa fa-plus"
          id="add-imagen"
          v-if="!agregandoImagenes"
          @click.prevent="agregandoImagenes = true" />
        </p>
        <b-row>
          <b-col cols="12">
            <image-uploader
              v-if="agregandoImagenes"
              :debug="1"
              :maxWidth="1024"
              :maxHeight="2048"
              :quality="0.7"
              :autoRotate=false
              outputFormat="verbose"
              :preview=false
              :className="['fileinput', { 'fileinput--loaded' : true }]"
              :capture="true"
              accept=".jpg,.png,.jpeg,.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.zip,.rar,.ai,.psd"
              doNotResize="['gif', 'svg', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'zip', 'rar', 'ai', 'psd']"
              @onUpload="uploadingImage"
              @input="setImage"
              @inputNoResize="setImageNoResize"
              @cancel="cancelarAgregarImagen">
            </image-uploader>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="12" md="4" v-for="imagen in imagenes" :key="imagen.id">
            <b-card no-header class="galeria-imagen">
              <template v-if="isImagen(imagen.fileName)">
                <b-img fluid
                  @click="consultarImagen(imagen.url)"
                  :src="imagen.url"></b-img>
              </template>
              <template v-if="isPDF(imagen.fileName)">
                <div class="galeria-pdf">
                  <div @click="consultarPDF(imagen)">
                    <pdf 
                      :src="imagen.url"
                      :page="1"
                      :scale="0.8"/>
                  </div>
                </div>
              </template>
              <template v-if="isWord(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file-word-o fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <template v-if="isPowerPoint(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file-powerpoint-o fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <template v-if="isExcel(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file-excel-o fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <template v-if="isOtro(imagen.fileName)">
                <div class="galeria-doc">
                  <i class="fa fa-file fa-2x" @click="downloadFile(imagen)"></i>
                  <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                </div>
              </template>
              <div class="titulo">
                <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
              </div>
              <div class="footer">
                <b-button size="sm" variant="danger" class="footer-button" 
                  @click.prevent="borrarImagen(imagen.id)">Borrar</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>

    </b-card>

    <!-- <b-row>
      <b-col cols="12">
        <b-card class="galeria-imagenes">
          <template slot="header">
            Imágenes de Referencia

            <i class="fa fa-plus"
              id="add-imagen"
              v-if="!agregandoImagenes"
              @click.prevent="agregandoImagenes = true" />
          </template>
          
          <b-row>
            <b-col cols="12">
              <image-uploader
                v-if="agregandoImagenes"
                :debug="1"
                :maxWidth="1024"
                :maxHeight="2048"
                :quality="0.7"
                :autoRotate=false
                outputFormat="verbose"
                :preview=false
                :className="['fileinput', { 'fileinput--loaded' : true }]"
                :capture="true"
                accept=".jpg,.png,.jpeg,.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.zip,.rar,.ai,.psd"
                doNotResize="['gif', 'svg', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'zip', 'rar', 'ai', 'psd']"
                @onUpload="uploadingImage"
                @input="setImage"
                @inputNoResize="setImageNoResize"
                @cancel="cancelarAgregarImagen">
              </image-uploader>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4" v-for="imagen in imagenes" :key="imagen.id">
              <b-card no-header class="galeria-imagen">
                <template v-if="isImagen(imagen.fileName)">
                  <b-img fluid
                    @click="consultarImagen(imagen.url)"
                    :src="imagen.url"></b-img>
                </template>
                <template v-if="isPDF(imagen.fileName)">
                  <div class="galeria-pdf">
                    <div @click="consultarPDF(imagen)">
                      <pdf 
                        :src="imagen.url"
                        :page="1"
                        :scale="0.8"/>
                    </div>
                  </div>
                </template>
                <template v-if="isWord(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file-word-o fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <template v-if="isPowerPoint(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file-powerpoint-o fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <template v-if="isExcel(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file-excel-o fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <template v-if="isOtro(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <div class="titulo">
                  <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
                </div>
                <div class="footer">
                  <b-button size="sm" variant="danger" class="footer-button" 
                    @click.prevent="borrarImagen(imagen.id)">Borrar</b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row> -->

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <b-modal ref="pdfModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen modalPDF">
      <app-pdf-modal
        :filename="selectedFilename"
        :url="selectedImageUrl"
        @close="closePDF">
      </app-pdf-modal>  
    </b-modal>

    <!-- <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>   -->

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import ImageUploader from '../../components/ImageUploader.vue';
import Imagen from  '../shared/imagenModal.vue';
import PdfModal from  '../shared/pdfModal.vue';
import pdf from 'vue-pdf'
import ABMButtons from '../shared/abmButtons.vue';
import { required, maxLength } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefCambio/getField',
  mutationType: 'briefCambio/updateField',
});

export default {
  name: 'BriefCambioOriginal',
  components: {
    ImageUploader,
    appImagen: Imagen,
    appPdfModal: PdfModal,
    pdf,
    appABMButton: ABMButtons,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    briefId: {
      type: Number,
      required: true
    },
    briefEntregaId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      agregandoImagenes: false,
      selectedFilename: '',
      selectedImageUrl: '',

      noValidar: true,
      cambiosValidos: null,
      cambiosInvalidosMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'cambios',
      'imagenes'
    ])
  },
  created() {
    let params = {
      briefId: this.briefId,
      briefEntregaId: this.briefEntregaId
    }

    this.showSpinner();
    this.$store.dispatch('briefCambio/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'cambios' || validarTodos) {
        if (this.$v.cambios.$error) {
          this.cambiosValidos = false;
          if (!this.$v.cambios.required) {
            this.cambiosInvalidosMsj = 'Debe ingresar el detalle de los cambios solicitados';
          } else if (!this.$v.cambios.maxLength) {
            this.cambiosInvalidosMsj = 'El detalle de los cambios solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.cambiosValidos = null;
          this.cambiosInvalidosMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          // this.$emit('registrarSolicitudCambios', params)
          this.showSpinner();
          this.$store.dispatch('briefCambio/save')
            .then(() => {
              let solicitudCambios = this.$store.getters['briefCambio/briefCambio'];
              // console.log(solicitudCambios);
              this.$emit('solicitudCambiosRegistrada', solicitudCambios);
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    cancelar() {
      this.$emit('cancelarSolicitudCambios')
    },

    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    isWord(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'doc') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'docx') {
        return true;
      }

      return false;
    },
    isPowerPoint(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'ppt') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'pptx') {
        return true;
      }

      return false;
    },
    isExcel(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'xls') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'xlsx') {
        return true;
      }

      return false;
    },
    isOtro(fileName) {
      return !this.isImagen(fileName)
        && !this.isPDF(fileName)
        && !this.isWord(fileName)
        && !this.isPowerPoint(fileName)
        && !this.isExcel(fileName);
    },

    agregarImagen() {
      this.agregandoImagenes = true;
    },
    cancelarAgregarImagen() {
      this.agregandoImagenes = false;
    },
    uploadingImage () {
      this.showSpinner();
    },
    setImage(output) {
      var file = this.dataURLtoFile(output.dataUrl, output.info.name);
      
      if (file) {
        this.$store.dispatch('briefCambio/uploadImagen', file)
          .then(() => this.key++)
          .catch(error => this.showErrorMsj(error))
          .finally(() => {
            this.agregandoImagenes = false;
            this.hideSpinner();
          });
      } else {
        this.hideSpinner();
      }
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    setImageNoResize(file) {
      if (file) {
        this.$store.dispatch('briefCambio/uploadImagen', file)
          .then(() => this.key++)
          .catch(error => this.showErrorMsj(error))
          .finally(() => {
            this.agregandoImagenes = false;
            this.hideSpinner();
          });
      } else {
        this.hideSpinner();
      }   
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(file) {
      this.selectedImageUrl = file.url;
      this.selectedFilename = file.fileName;
      this.$refs.pdfModal.show();
    },
    closePDF() {
      this.$refs.pdfModal.hide();
    },
    consultarDocumento(url) {
      window.open(url, '_blank');
    },
    downloadFile(file) {
      if (file.url) {
        fetch(file.url)
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, file.fileName);
          });
      }
    },    
    borrarImagen(imagenId) {
      this.showModalConfirm('¿Desea eliminar el documento seleccionado?', 
        this.borrarImagenSeleccionada.bind(this, imagenId), 'Si', 
        null, 'No');
    },
    borrarImagenSeleccionada(imagenId) {
      this.$store.dispatch('briefCambio/deleteImagen', imagenId)
        .then(() => this.key++)
        .catch(error => this.showErrorMsj(error));
    },
  },
  validations: {
    cambios: {
      required,
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
  .brief-cambios-original-add .galeria-imagen {
    border: none;
    /* padding-top: 20px; */
    text-align: center;
  }
  .brief-cambios-original-add .galeria-imagen .card-body {
    padding: 0;
  }
  .brief-cambios-original-add .galeria-imagen img {
    position: relative;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .brief-cambios-original-add .galeria-imagen .footer {
    height: 40px;
    display: inline-block;
    width: 100%;
  }
  .brief-cambios-original-add .galeria-imagen .footer button {
    display: none;
    margin-right: 0;
    width: 100%;
  }
  .brief-cambios-original-add .galeria-imagen:hover .footer button {
    display: inline-block;
  }
  @media(max-width:766px){
    .brief-cambios-original-add .galeria-imagen .footer button {
      display: inline-block;
    }
  }

  /* .brief-cambios-original-add .galeria-imagen, */
  .brief-cambios-original-add .galeria-pdf {
    max-height: 160px !important;
    overflow: hidden;
  }
  .brief-cambios-original-add .galeria-pdf > div {
    cursor: pointer;
  }

  .brief-cambios-original-add .galeria-doc {
    display: block;
  }
  .brief-cambios-original-add .galeria-doc i,
  .brief-cambios-original-add .galeria-doc label {
    display: block;
    cursor: pointer;
  }
  .brief-cambios-original-add .galeria-doc i {
    color: rgb(20,76,129);
    margin-bottom: 10px;
  }
  .brief-cambios-original-add .galeria-doc label {
    margin-bottom: 20px;
  }

  .brief-cambios-original-add .subtitulo,
  .brief-cambios-original-add .subtitulo label,
  .brief-cambios-original-add .subtitulo button {
    display: inline-block !important;
  }

  .brief-cambios-original-add #add-imagen {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-cambios-original-add #add-imagen:hover {
    color: #1b8eb7;
  }


  .brief-cambios-original-add .dropdown-menu li {
    list-style: none !important;
  }
  .brief-cambios-original-add .titulo p {
    font-size: 0.8em;
  }

  .brief-cambios-original-add #add-imagen {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-cambios-original-add #add-imagen:hover {
    color: #1b8eb7;
  }


</style>
